

$(document).ready(() => {
    $(document).on('click', 'a[href="#"]', e => { e.preventDefault() });

    $('[data-toggle]').on('click', function () {
        let element = $(this),
            toggle_name = element.data('toggle'),
            target_name = element.data('target'),
            target_element = $('[data-toggle="showbox"][data-target="' + target_name + '"]');

        if (toggle_name == 'openbox') {
            let target_status = target_element.attr('data-status');
            $('[data-toggle="showbox"]:not([data-target="' + target_name + '"])').attr('data-status', 'false');
            $('[data-toggle="openbox"]:not([data-target="' + target_name + '"])').attr('data-status', 'false');
            if (target_status == 'false') {
                target_element.attr('data-status', 'true');
                element.attr('data-status', 'true');
            } else {
                target_element.attr('data-status', 'false');
                element.attr('data-status', 'false');
            }
        } else if (toggle_name == 'closebox') {
            target_element.attr('data-status', 'false');
            element.attr('data-status', 'false');
        }
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('[data-toggle="showbox"],[data-toggle="openbox"]').length) {
            $('[data-toggle="showbox"]').attr('data-status', 'false');
            $('[data-toggle="openbox"]').attr('data-status', 'false');
        }
    });

    $(document).on('keyup', function (e) {
        if (e.key === "Escape") {
            $('[data-toggle="showbox"]').attr('data-status', 'false');
            $('[data-toggle="openbox"]').attr('data-status', 'false');
        }
    });

    //=====end menu mobile======//

    //========== sliders ==============//
    var main_slider = new Swiper('.main-slider .swiper', {
        spaceBetween: 20,
        slidesPerView: 1,
        loop: 1,
        speed: 1500,
        autoplay: {
            delay: 4000,
            disableOnInteraction: 0,
            pauseOnMouseEnter: 1
        },
        pagination: {
            el: '.swiper-pagination',
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: 1
        },
        on: {
            init: function () {
                let bg_color = $('.main-slider .swiper-slide.swiper-slide-active').attr('data-background-color')
                $('.main-slider__wrapper').css('background-color', bg_color)
            },
            slideChangeTransitionStart: function () {
                let bg_color = $('.main-slider .swiper-slide.swiper-slide-active').attr('data-background-color')
                $('.main-slider__wrapper').css('background-color', bg_color)
            },
        },

    });

    var packages_slider = new Swiper('.packages__slider .swiper', {
        spaceBetween: 50,
        slidesPerView: 1,
        loop: 1,
        centeredSlides: 1,
        allowTouchMove: 0,
        clickable: true,
        // slideToClickedSlide: 1,
        // autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: 0,
        //     pauseOnMouseEnter: 1
        // },
        pagination: {
            el: '.packages__slider .swiper-pagination',
        },
        navigation: {
            nextEl: '.packages__slider .swiper-btn-next',
            prevEl: '.packages__slider  .swiper-btn-prev',
        },
        breakpoints: {

            1200: {
                spaceBetween: -100,
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: -300,
            },
        },

    })


    var panels_slider = new Swiper('.panels__slider .swiper', {
        spaceBetween: 40,
        slidesPerView: 1,
        loop: 1,
        slideToClickedSlide: 1,
        // centeredSlidesBounds: 1,
        // autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: 0,
        //     pauseOnMouseEnter: 1
        // },
        pagination: {
            el: '.swiper-pagination',
        },
        breakpoints: {
            1700: {
                slidesPerView: 4,
            },
            1300: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 2,
            },
        },
        navigation: {
            nextEl: '.panels__slider .swiper-btn-next',
            prevEl: '.panels__slider .swiper-btn-prev',
        },
    })




    var blog_slider = new Swiper('.blog .swiper-blog', {
        spaceBetween: 100,
        slidesPerView: 1,
        loop: 1,
        // autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: 0,
        //     pauseOnMouseEnter: 1
        // },
        centeredSlides: 1,
        navigation: {
            nextEl: '.swiper-blog .swiper-btn-next',
            prevEl: '.swiper-blog .swiper-btn-prev',
        },
        breakpoints: {
            1600: {
                slidesPerView: 1,
            },
            1400: {
                slidesPerView: 1.65,
            },
            1200: {
                slidesPerView: 1.45,
            },
        }
    })

    var news_slider = new Swiper('.blog .swiper-news', {
        spaceBetween: 100,
        slidesPerView: 1,
        loop: 1,
        // autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: 0,
        //     pauseOnMouseEnter: 1
        // },
        centeredSlides: 1,
        navigation: {
            nextEl: '.swiper-news .swiper-btn-next',
            prevEl: '.swiper-news .swiper-btn-prev',
        },
        breakpoints: {
            1600: {
                slidesPerView: 1,
            },
            1400: {
                slidesPerView: 1.65,
            },
            1200: {
                slidesPerView: 1.45,
            },
        }
    })


    var awards_text = new Swiper('.awards__text .swiper', {
        spaceBetween: 30,
        slidesPerView: 1,
        loop: 1,
        centeredSlides: 1,
        allowTouchMove: false,
        // autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: 0,
        //     pauseOnMouseEnter: 1
        // },
    })

    var awards_slider = new Swiper('.awards__slider .swiper', {
        spaceBetween: -120,
        slidesPerView: 2,
        loop: 1,
        slideToClickedSlide: 1,
        centeredSlides: 1,
        // autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: 0,
        //     pauseOnMouseEnter: 1
        // },
        navigation: {
            nextEl: '.awards__slider .swiper-btn-next',
            prevEl: '.awards__slider .swiper-btn-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
        on: {
            slideNextTransitionStart: function () {
                awards_text.slideNext()
            },
            slidePrevTransitionStart: function () {
                awards_text.slidePrev()
            },
        },
    })

    // awards_slider.controller.control = awards_text;
    // awards_text.controller.control = awards_slider;

    var faq_slider = new Swiper('.faq .swiper', {
        spaceBetween: 50,
        slidesPerView: 1,
        loop: 1,
        // autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: 0,
        //     pauseOnMouseEnter: 1
        // },
        navigation: {
            nextEl: '.faq .swiper-btn-next',
            prevEl: '.faq .swiper-btn-prev',
        },
        breakpoints: {
            1500: {
                slidesPerView: 2,
            },
        }
    })

    var brands_slider = new Swiper('.brands .swiper', {
        spaceBetween: 30,
        slidesPerView: 3,
        loop: 1,
        slideToClickedSlide: 1,
        // centeredSlides: 1,
        // autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: 0,
        //     pauseOnMouseEnter: 1
        // },
        breakpoints: {
            1500: {
                slidesPerView: 7,
            },
            1200: {
                slidesPerView: 5,
            },
            992: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
        }
    })

    var comments_slider = new Swiper('.comments .swiper', {
        spaceBetween: 30,
        slidesPerView: 1,
        loop: 1,
        // centeredSlides: 1,
        // autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: 0,
        //     pauseOnMouseEnter: 1
        // },
        pagination: {
            el: '.swiper-pagination',
        },
        breakpoints: {
            1200: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 2,
            },
        }
    })

    var app_slider = new Swiper('.app__image__slider .swiper', {
        spaceBetween: 0,
        slidesPerView: 1,
        // loop: 1,
        // autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: 0,
        //     pauseOnMouseEnter: 1
        // },
        on: {
            slideChange: function () {
                $(`.app__titles a[data-slide="${this.realIndex}"]`).addClass('active').siblings().removeClass('active')
            },
            init: function () {
                $(`.app__titles a[data-slide="${this.realIndex}"]`).addClass('active').siblings().removeClass('active')
            },
        }
    })

    $(document).on('click', '.app__titles a', e => {
        let index = $(e.currentTarget).attr('data-slide')
        $(e.currentTarget).addClass('active').siblings().removeClass('active')
        app_slider.slideTo(index)
    })



    var symbols_slider = new Swiper('.main-footer__bottom__symbols .swiper', {
        spaceBetween: 15,
        slidesPerView: 2,
        loop: 1,
        // centeredSlides: 1,
        // autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: 0,
        //     pauseOnMouseEnter: 1
        // },
    })

    //============== end sliders ===============//


    $('.branches__map .pin').each((i, e) => {
        let left = $(e).attr('data-x'),
            top = $(e).attr('data-y');
        $(e).css({ left: `${left}%`, top: `${top}%` })
    })

    //============ tab =========================//


    const update_slider = (target) => {

        if (target === "tab-packages") {
            if (packages_slider.length > 1) {
                packages_slider.forEach(slider => {
                    slider.update()
                })
            } else {
                packages_slider.update()
            }
        } else if (target === "tab-panels") {
            if (panels_slider.length > 1) {
                panels_slider.forEach(slider => {
                    slider.update()
                })
            } else {
                panels_slider.update()
            }
        }
    }


    $(document).on('click', '[data-tab]', function () {
        let $this = $(this),
            tab = $this.data('tab'),
            target = $this.data('tab-target');

        $('[data-tab][data-tab-target="' + target + '"]').removeClass('active');
        $this.addClass('active');

        $('[data-tab-content][data-tab-target="' + target + '"]').removeClass('active');
        $('[data-tab-content="' + tab + '"][data-tab-target="' + target + '"]').addClass('active');

        update_slider(target);

    });
    //================== end tab ================//

    $(document).on('click', '.about__video i', e => {
        let video = $('.about__video video')[0]
        if (video.paused == true) {
            video.play();
            $(e.currentTarget).remove();
        }
    });


    function getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            $(".download-app").addClass("active");
            let data_android = $(".download-app__wrapper__text a").data('android');
            $(".download-app__wrapper__text a").attr("href",data_android);
            $(".download-app__wrapper__text a").html("دانلود اپلیکیشن اندروید مشیر");
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            $(".download-app").addClass("active");
            let data_ios = $(".download-app__wrapper__text a").data('ios');
            $(".download-app__wrapper__text a").attr("href",data_ios);
            $(".download-app__wrapper__text a").html("دانلود اپلیکیشن ios مشیر");

        }

    }

    getMobileOperatingSystem();
    
    $(document).on('click', '.download-app__wrapper__close svg', e => {
        $(e.currentTarget).closest(".download-app").remove();
    });

});





